import { clamp } from '../geometry';
import type { Viewport, XYPosition } from '../types';
import type { ZoomLimits } from './fitView';

/**
 * Viewport at `zoom` (clamped to the limits) that keeps the flow point under `point` (renderer coordinates)
 * in place — zooming "around the cursor".
 */
export const zoomAroundPoint = (viewport: Viewport, point: XYPosition, zoom: number, { minZoom, maxZoom }: ZoomLimits): Viewport => {
  const nextZoom = clamp(zoom, minZoom, maxZoom);
  const ratio = nextZoom / viewport.zoom;
  return {
    x: point.x - (point.x - viewport.x) * ratio,
    y: point.y - (point.y - viewport.y) * ratio,
    zoom: nextZoom,
  };
};
